import React, { useCallback, useEffect } from "react";
// import { useRouter } from "next/router";
import Head from "next/head";

import RecipeListPage from "@/containers/RecipeListPage";

// import { useAppDispatch } from "@/hooks";

// import * as actions from "@/redux/RecipeReducer";
import * as actions from "@/redux/RecipeReducer";
import * as dashboardActions from "@/redux/DashboardReducer";
import { wrapper } from "@/redux/Store";

const RecipePage = () => {
  // const router = useRouter();
  // const dispatch = useAppDispatch();

  const {
    title = "Healthy yet Tasty Recipes by Shyft",
    share_meta_image_link:
      thumbnail = "https://d1mxd7n691o8sz.cloudfront.net/static/recipe/recipe/2023-03/Jeera-Alu-5784ce80f0554e73ae7bb4795a2337f0.jpg",
    description = "Healthy food shouldn't be boring. Get hundreds of healthy yet tasty recipes approved by certified nutritionists. | Shyft Health",
  } = {};

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:site_name" content="Shyft" />
        <meta property="og:image" content={thumbnail} />
        <meta name="twitter:card" content="summary_large_image" />
        <link
          rel="canonical"
          href="https://www.betheshyft.com/recipes/"
          key="canonical"
        />
      </Head>
      <RecipeListPage pageType="HOME" />
    </>
  );
};

export default RecipePage;

export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async () => {
    const [
      // recipesList,
      attributeAndCategories,
      ribbonData,
    ] = await Promise.all([
      // store.dispatch(actions.getRecipeThread({})),
      store.dispatch(actions.getAttributeAndCategories()),
      store.dispatch(dashboardActions.getRibbonData({ pathname: "recipes" })),
    ]);
  }
);
